import React from 'react';

import { Button } from 'reactstrap';

const positionMap = { left: 'flex-start', center: 'center', right: 'flex-end' };

export default function ButtonDisplay({ attributes, saveForm }) {
  return (
    <div style={{width: '100%', display: 'flex', justifyContent: positionMap[attributes.btnPosition] || 'flex-end'}}>
      <Button
        className="displayed-label"
        style={{
          backgroundColor: attributes.btnColor,
        }}
        onClick={saveForm}
      >
        <span style={{color: attributes.fontColor}}>{attributes.btnText}</span>
      </Button>
    </div>
  )
}
